module.exports = __webpack_public_path__ + "img/img22.da4fcc05.svg";